import {ReferenceIdSchema} from '@cohort/shared/schema/common/referenceId';
import {z} from 'zod';

export const ReferenceIdFormSchema = z
  .string()
  .refine(value => value === '' || value.trim().length >= 3, {message: 'errorTooShort3'})
  .transform(value => (value === '' ? undefined : value))
  .pipe(ReferenceIdSchema.optional());
